import { render, staticRenderFns } from "./FormSidebar.vue?vue&type=template&id=bab483fc&"
import script from "./FormSidebar.vue?vue&type=script&lang=js&"
export * from "./FormSidebar.vue?vue&type=script&lang=js&"
import style0 from "./FormSidebar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports